import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.TRANSLATION_CAPTIONS],
  data () {
    return {
      logo: getPlanLogo(planTypes.TRANSLATION_CAPTIONS),
      title: this.$t('billing.translation_caption.title'),
      subtitle: '',
      capacityKey: 'participants',
      planType: planTypes.TRANSLATION_CAPTIONS,
      description: this.$t('billing.translation_caption.desc'),
      licenseTooltip: this.$t('billing.translation_caption.license_tooltip'),
      configDescription: this.$context.is.addQty ? '' : this.$t('billing.translation_caption.config_desc'),
    }
  }
};
